import React from 'react';

import ErrorPage from 'components/ErrorPage/ErrorPage';
import connectWithApp from 'hoc/connectWithApp';
import {ErrorContext} from 'models/app';
import {RumErrorLevel, sendRumError} from 'services/rum';
import {Query} from 'models/api';

export interface ErrorProps {
    error: unknown;
    errorType?: string;
    statusCode: number;
    page: string;
    query: Query;
}

class Error extends React.Component<ErrorProps> {
    static getInitialProps({res, err, errorType, page, query}: ErrorContext) {
        let status;

        if (res) {
            status = res.statusCode;
        } else if (err) {
            status = err.statusCode ?? err.response?.status;
        }

        return {
            statusCode: status ?? 500,
            error: err,
            errorType,
            page,
            query,
        };
    }

    componentDidMount() {
        const {error, errorType, statusCode, page, query} = this.props;
        sendRumError({
            type: errorType ?? 'error_page',
            level: statusCode === 404 ? RumErrorLevel.Warn : RumErrorLevel.Error,
            error,
            page,
            additional: {query},
        });
    }

    render() {
        const {statusCode} = this.props;

        return <ErrorPage code={statusCode} />;
    }
}

export default connectWithApp(Error);
